import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { LOGIN_PATH } from "@routes/path";
import logoutApi from "@services/api/authentication/logout";

function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        localStorage.clear(); 
       
        await logoutApi();
        
      } catch (error) {
        console.log("Error calling logout endpoint or timeout:", error);
        
      } finally {
        navigate(LOGIN_PATH);
      }
    };

    performLogout();
  }, [navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default LogoutPage;